import { render, staticRenderFns } from "./ResolucionesNewOrEdit.vue?vue&type=template&id=92b730a0&scoped=true&"
import script from "./ResolucionesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ResolucionesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResolucionesNewOrEdit.vue?vue&type=style&index=0&id=92b730a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b730a0",
  null
  
)

export default component.exports